<template>
  <div class="header">
    <v-navigation-drawer v-model="drawer" app right width="276" class="sidebar">
      <v-container fluid class="px-1">
        <div class="sidebar__avatar-wrapper mt-lg-2 mt-11 mb-3">
          <div>
            <img
              src="@/assets/images/logo.png"
              alt="profile Avatar"
              width="110px"
            />
            <h2 class="text-p-second">
              سامانه جامع مشترکین <br />
              شهرک صنعتی شکوهیه
            </h2>
          </div>
        </div>

        <v-col cols="12">
          <v-autocomplete
            v-model="selectedRole"
            :items="userRoles"
            outlined
            dense
            hide-details
            fill
            dark
            :clearable="false"
            no-data-text="نقشی برای کاربر ثبت نشده است"
            color="white"
            item-color="first"
            @input="changeRole"
          >
            <template #label>
              <label class="text-p-white p-fs-s">
                نقش‌های شما (دسترسی‌ها)
              </label>
            </template>
          </v-autocomplete>
        </v-col>

        <v-list v-if="reloadNavbar" class="mb-5 pt-0">
          <template v-for="(nav, navIndex) in navItems">
            <v-list-item
              v-if="nav.to"
              :key="`${navIndex}-a`"
              :to="{ name: nav.to }"
              link
              dark
            >
              <v-list-item-icon>
                <v-icon>{{ nav.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ nav.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              v-if="nav.subItems && nav.subItems.length > 0"
              :key="`${navIndex}-b`"
              :prepend-icon="`${nav.icon} fa-em`"
              v-model="nav.active"
              append-icon="fas fa-chevron-down fa-sm"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ nav.label }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(sub, subIndex) in nav.subItems"
                :key="subIndex"
                :to="{ name: sub.to }"
                link
                dark
              >
                <v-list-item-icon>
                  <v-icon small>{{ sub.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ sub.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-divider
              color="#1ABB9C"
              class="my-2 mx-1 sidebar-divider"
              :key="navIndex"
              v-if="nav.to || (nav.subItems && nav.subItems.length > 0)"
            />
          </template>
        </v-list>

        <span class="sidebar-bottom-caption">
          pitms Web Application v {{ version }}
        </span>
      </v-container>
    </v-navigation-drawer>

    <v-app-bar
      flat
      app
      color="#ccd9e5"
      style="border-bottom: 4px ridge #7799bb !important"
    >
      <v-btn
        @click="toggleSidebar()"
        class="drawer-hide"
        elevation="0"
        fab
        v-if="drawer"
      >
        <v-icon> mdi-menu-right </v-icon>
      </v-btn>
      <v-btn
        @click="toggleSidebar()"
        class="drawer-show"
        elevation="0"
        fab
        v-else
      >
        <v-icon> mdi-menu </v-icon>
      </v-btn>

      <v-toolbar-title>
        <h3 class="mr-8">هیئت مدیره شهرک شکوهیه</h3>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- <NotifyDropDown /> -->

      <!-- <MessageDropDown /> -->

      <AccountDropDown />
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import AccountDropDown from "./dropDown/Account";
// import MessageDropDown from "./dropDown/Message";
// import NotifyDropDown from "./dropDown/Notify";

export default {
  name: "TheHeader",
  components: {
    AccountDropDown,
    // MessageDropDown,
    // NotifyDropDown,
  },
  data() {
    return {
      alert,
      label,
      selectedRole: null,
      version: process.env.VUE_APP_VERSION,
      drawer: null,
      id: 0,
      navItems: [
        {
          to: "Dashboard",
          label: label.menu.dashboard,
          icon: "mdi-home",
          active: false,
          subItems: false,
        },
        {
          to: null,
          label: label.menu.baseInformation,
          icon: "mdi-database",
          active: false,
          subItems: [
            {
              to: "Setting",
              label: label.menu.setting,
              icon: "mdi-subdirectory-arrow-left",
              id: 20006,
            },
            {
              to: "TransactionInfo",
              label: label.menu.transactionInfo,
              icon: "mdi-subdirectory-arrow-left",
              id: 20013,
            },
            {
              to: "ActivityGroup",
              label: label.menu.activityGroup,
              icon: "mdi-subdirectory-arrow-left",
              id: 20001,
            },
            {
              to: "InternalUnit",
              label: label.menu.internalUnit,
              icon: "mdi-subdirectory-arrow-left",
              id: 20002,
            },
            {
              to: "AutomationType",
              label: label.menu.automationType,
              icon: "mdi-subdirectory-arrow-left",
              id: 20003,
            },
            {
              to: "BillboardList",
              label: label.menu.billboard,
              icon: "mdi-subdirectory-arrow-left",
              id: 20004,
            },
            {
              to: "Vehicle",
              label: label.menu.vehicle,
              icon: "mdi-subdirectory-arrow-left",
              id: 20005,
            },
            {
              to: "TariffList",
              label: label.menu.tariff,
              icon: "mdi-subdirectory-arrow-left",
              id: 20007,
            },
            {
              to: "WaterBillPeriod",
              label: label.menu.waterBillPeriod,
              icon: "mdi-subdirectory-arrow-left",
              id: 20008,
            },
            {
              to: "ServiceType",
              label: label.menu.serviceType,
              icon: "mdi-subdirectory-arrow-left",
              id: 20009,
            },
            {
              to: "NoticeList",
              label: label.menu.notice,
              icon: "mdi-subdirectory-arrow-left",
              id: 20010,
            },
            {
              to: "SubscriberList",
              label: label.menu.subscriber,
              icon: "mdi-subdirectory-arrow-left",
              id: 20011,
            },
          ],
        },
        {
          to: null,
          label: label.menu.operation,
          icon: "mdi-wrench",
          active: false,
          id: 0,
          subItems: [
            {
              to: "AddTransit",
              label: label.menu.addTransit,
              icon: "mdi-subdirectory-arrow-left",
              id: [3000101, 3000105],
            },
            {
              to: "TransitList",
              label: label.menu.transit,
              icon: "mdi-subdirectory-arrow-left",
              id: [30001, 3000107],
            },
            // {
            //   to: "FieldReportList",
            //   label: label.menu.fieldReport,
            //   icon: "mdi-subdirectory-arrow-left",
            //   id: [30003, 3000304],
            // },
            {
              to: "MeterReading",
              label: label.menu.meterReading,
              icon: "mdi-subdirectory-arrow-left",
              id: [30004, 3000407],
            },
            {
              to: "WaterBillList",
              label: label.menu.waterBill,
              icon: "mdi-subdirectory-arrow-left",
              id: [30005, 3000506],
            },
            {
              to: "ChargeBillList",
              label: label.menu.chargeBill,
              icon: "mdi-subdirectory-arrow-left",
              id: [30006, 3000605],
            },
            {
              to: "AutomationList",
              label: label.menu.automation,
              icon: "mdi-subdirectory-arrow-left",
              id: [30007, 3000704],
            },
            {
              to: "BillboardRequestList",
              label: label.menu.billboardRequest,
              icon: "mdi-subdirectory-arrow-left",
              id: [30008, 3000805],
            },
            {
              to: "ServiceRequestList",
              label: label.menu.serviceRequest,
              icon: "mdi-subdirectory-arrow-left",
              id: 30009,
            },
            {
              to: "VoucherCartable",
              label: label.menu.voucherCartable,
              icon: "mdi-subdirectory-arrow-left",
              id: 30011,
            },
          ],
        },
        {
          to: null,
          label: label.menu.reports,
          icon: "mdi-book-multiple",
          id: 0,
          active: false,
          subItems: [
            {
              to: "TransactionReport",
              label: label.menu.transactionReport,
              icon: "mdi-subdirectory-arrow-left",
              id: 40001,
            },
          ],
        },
        {
          to: null,
          label: label.menu.systemManagement,
          icon: "mdi-application-cog",
          id: 0,
          active: false,
          subItems: [
            // {
            //   to: "Person",
            //   label: label.menu.person,
            //   icon: "mdi-subdirectory-arrow-left",
            //   id: 10004,
            // },
            {
              to: "UserList",
              label: label.menu.user,
              icon: "mdi-subdirectory-arrow-left",
              id: 10001,
            },
            {
              to: "Roles",
              label: label.menu.roles,
              icon: "mdi-subdirectory-arrow-left",
              id: 10002,
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userPermissions: "identityX/defaultPermissions",
      reloadNavbar: "identityX/reloadNavbar",
      userRoles: "identityX/userRoles",
    }),
  },
  watch: {
    userPermissions() {
      this.createSidebarMenu();
    },
  },
  methods: {
    changeRole() {
      localStorage.setItem("selectedRole", JSON.stringify(this.selectedRole));
      this.reloadPermissions();
      this.$store.commit("identityX/reloadNavbar", false);
      this.$router.push({ name: "Dashboard" }).catch(() => {});
    },
    reloadPermissions() {
      this.$store.dispatch("identityX/getUserPermission", this.selectedRole);
    },
    setDefaultRole(id) {
      this.selectedRole = id;
    },
    createSidebarMenu() {
      if (this.navItems && this.navItems.length > 0) {
        this.navItems.forEach((item) => {
          if (item.subItems && item.subItems.length > 0) {
            let mySub = [];
            item.subItems.forEach((subItem) => {
              if (subItem && subItem.id && subItem.id.length > 1) {
                subItem.id.forEach((idItem) => {
                  if (this.userPermissions.includes(idItem)) {
                    mySub.push(subItem);
                  }
                });
              } else {
                if (this.userPermissions.includes(subItem.id)) {
                  mySub.push(subItem);
                }
              }
            });
            let uniqueItems = [...new Set(mySub)];
            item.subItems = uniqueItems;
          }
        });
      }
      setTimeout(() => {
        this.$store.commit("identityX/reloadNavbar", true);
      }, 800);
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
    },
    logout() {
      this.$store.dispatch("logoutCustomer");
    },
  },
  mounted() {
    let getRoles = JSON.parse(localStorage.getItem("userRoles"));
    let getDefault = JSON.parse(localStorage.getItem("selectedRole"));
    let getPermissions = JSON.parse(localStorage.getItem("rolePermissions"));
    if (getRoles && getRoles.length > 0) {
      const payload = {
        roles: getRoles,
        defaultRoleId: getDefault,
        permissions: getPermissions,
      };
      this.$store.commit("identityX/setUserAccess", payload);
      this.setDefaultRole(getDefault);
    }
  },
};
</script>
